/* global axios */
import ApiClient from '../ApiClient';

class PilotCopilotThreads extends ApiClient {
  constructor() {
    super('pilot/copilot_threads', { accountScoped: true });
  }

  destroyAll() {
    return axios.delete(`${this.url}/delete_all`);
  }
}

export default new PilotCopilotThreads();
